import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileStickyCTA from "./MobileStickyCTA";

export default function SubpageLayout({ children, testId }) {
  return (
    <div data-testid={testId} className="bg-white text-pkcharcoal">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <MobileStickyCTA />
      <div className="lg:hidden h-20" aria-hidden="true" />
    </div>
  );
}
